import { MinzeElement, EventListeners } from 'minze'
import MainModule from '../../../modules/main'
import { Routing } from '../../../modules/routing'
import { getVisibleWidth } from '../../../modules/utils'
import { Locale } from '../../../modules/locale'
import { SCREEN_WIDTHS } from '../../../constants'

Locale.getInstance().registerKeySet('fr', 'partnerSignupCompleted', {
  requestSentTitle: 'Demande envoyée!',
  requestSentMessage:
    "Nous avons bien reçu votre demande, vous recevrez un courriel à l'adresse fournie dès que nous aurons validé votre inscription.",
  homePageButton: "Page d'accueil",
})

Locale.getInstance().registerKeySet('en', 'partnerSignupCompleted', {
  requestSentTitle: 'Request sent!',
  requestSentMessage:
    'We have received your request, you will receive an email at the address provided as soon as we have validated your registration.',
  homePageButton: 'Home page',
})

export interface LvcPartnerSignupCompletedModalContent {
  iconSize: string
}

export class LvcPartnerSignupCompletedModalContent extends MinzeElement {
  onClickPartnerPage() {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    routing.goTo(Routing.HOST)
  }

  html(): string {
    let mobile = getVisibleWidth() < SCREEN_WIDTHS.DESKTOP_SMALL
    let titleSize = mobile ? 'titleMobileSmall' : 'titleDesktopSmall'
    let messageSize = mobile ? 'medium' : 'large'
    this.iconSize = mobile ? '300px' : '400px'
    return /*html*/ `
      <div class="container">
        <lvc-box class="icon">
          <lvc-charlie-peacesign-icon width="${this.iconSize}" height="${this.iconSize}"></lvc-charlie-peacesign-icon>
        </lvc-box>
        <lvc-box class="title">
          <lvc-text font-preset=${titleSize} class="lvc-modal-title">${Locale.getKey('partnerSignupCompleted.requestSentTitle')}</lvc-text>
        </lvc-box>
        <lvc-box class="message">
          <lvc-text font-preset=${messageSize} class="lvc-modal-title">${Locale.getKey('partnerSignupCompleted.requestSentMessage')}</lvc-text>
        </lvc-box>
        <lvc-box class="buttonContainer">
          <lvc-button enable-hover-box-shadow="true" width="${window.matchMedia(' (max-width: 730px)').matches ? '100%' : 'fit-content'}" class="button"
              height="100%" width="100%" font-size="1rem" font-weight="500" padding="14px 24px" name="partnerPageButton" > ${Locale.getKey('partnerSignupCompleted.homePageButton')} </lvc-button>
        </lvc-box>
      </div>
    `
  }

  css() {
    let mobile = getVisibleWidth() < SCREEN_WIDTHS.DESKTOP_SMALL
    this.iconSize = mobile ? '300px' : '400px'

    return /*css*/ `
      .container {
        text-align: center;
      }
      .message {
        margin-top: 10px;
      }
      .buttonContainer {
        margin-top: 32px;
        margin-bottom: 20px;
        display: flex;
        justify-content: center; /* Center the child elements horizontally */
        align-items: center;
      }
      .icon{
        display: flex;
        justify-content: center; /* Center the child elements horizontally */
        align-items: center;
      }
      lvc-charlie-peacesign-icon{
        display: flex;
        align-self: center;
        height: ${this.iconSize};
        width: ${this.iconSize};
      }
    `
  }

  eventListeners: EventListeners = [
    ['[name=partnerPageButton]', 'click', this.onClickPartnerPage.bind(this)],
  ]
}
